var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "eye-svg",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    className: "svg eye",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.8,15.38C31.51,15,24.7,5.8,16,5.8S.49,15,.2,15.38a1.05,1.05,0,0,0,0,1.24C.49,17,7.3,26.2,16,26.2S31.51,17,31.8,16.62A1.05,1.05,0,0,0,31.8,15.38ZM16,24.09C9.59,24.09,4,18,2.4,16,4,14,9.58,7.91,16,7.91S28,14,29.6,16C28,18,22.42,24.09,16,24.09Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16,9.67A6.33,6.33,0,1,0,22.33,16,6.34,6.34,0,0,0,16,9.67Zm0,10.55A4.22,4.22,0,1,1,20.22,16,4.22,4.22,0,0,1,16,20.22Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.2146af3f7496e3a4a33dedf7967c142d.svg";
export { ForwardRef as ReactComponent };